// Domanda 12 asks for the same nine beneficiary categories in both schede, but the scheda
// iniziale splits them over three questions while the scheda di aggiornamento keeps one matrix.
export const AGE_GROUP_KEYS = [
    'question13_persone_anziane_di_eta_65_75_numero',
    'question13_persone_anziane_di_eta_75_85_numero',
    'question13_persone_anziane_over_85_numero',
];

export const ACTUAL_AGE_GROUP_KEYS = [
    'question13_persone_anziane_di_eta_65_75_column_1',
    'question13_persone_anziane_di_eta_75_85_column_1',
    'question13_persone_anziane_over_85_column_1',
];

export const AUTONOMOUS_KEY = 'question24_persone_anziane_autonomequasi_autonome_nelle_seguenti_attivita_movimenti_cura_e_igiene_personale_pulizia_quotidiana_della_casa_spesa_e_commissioni_correnti_numero';

export const BARELY_AUTONOMOUS_KEY = 'question24_persone_anziane_poco_autonomenon_autonome_nelle_seguenti_attivita_movimenti_cura_e_igiene_personale_pulizia_quotidiana_della_casa_spesa_e_commissioni_correnti_numero';

// Categorie 6-9.
export const CAREGIVER_KEYS = [
    'question25_famigliari_inserire_solo_un_famigliare_per_anziano_numero',
    'question25_altri_caregivers_ad_es_badanti_numero',
    'question25_volontari_numero',
    'question25_operatori_numero',
];

// Categorie 8-9.
export const COMMUNITY_KEYS = [
    'question25_volontari_numero',
    'question25_operatori_numero',
];

export const OBJECTIVES = {
    home: 'Offerta di servizi domiciliari',
    information: 'Offerta di servizi informativi/di orientamento',
    sociability: 'Promozione della socialità/attivazione cognitiva dell’anziano (attività non svolte presso il domicilio dell’anziano, nel qual caso considerarle incluse nella categoria “Offerta di servizi domiciliari”)',
    members: 'Formazione e supporto per famigliari/caregivers (escludere la ricomposizione dei servizi, da includere in ‘Offerta di servizi informativi/di orientamento’)',
    awareness: 'Sensibilizzazione e attivazione della comunità (escludere le attività di ricomposizione delle risorse, per cui è prevista apposita scheda)',
};

export const sumAnswers = (submission: any, keys: string[]): number =>
    keys.map(key => submission[key] || 0).reduce((a: number, b: number) => a + b, 0);

// A UoA can submit the same scheda several times: only the most recent one counts.
export const latestPerUoa = (submissions: any[]): any[] => {
    const latest = new Map<number, any>();

    submissions.forEach((submission: any) => {
        const previous = latest.get(submission.uoa_id);

        if (!previous || submission.id > previous.id) {
            latest.set(submission.uoa_id, submission);
        }
    });

    return Array.from(latest.values());
};

export const percentageOf = (amount: number, total: number): number =>
    total > 0 ? (amount / total) * 100 : 0;

// The linee guida average the percentages themselves, each project or activity weighing 1.
export const meanOf = (values: number[]): number =>
    values.length > 0 ? values.reduce((a: number, b: number) => a + b, 0) / values.length : 0;
